export default {
  text: 'The map is provided by Google. Loading it sends your IP address to Google.',
  buttons: {
    show_map: 'Show map',
    retry: 'Try again',
  },
  errors: {
    map_unavailable: "The map couldn't load.",
  },
};
